module.exports = __webpack_public_path__ + "static/media/roue_biodiversite.e711731e.png";